import { Injectable, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable()
export class Urls implements OnInit {


  // public static API_ENDPOINT = "http://localhost:8080/PortalWebService";
  //       localStorage.setItem("ENDPOINT",data.API_ENDPOINT)
  public static API_ENDPOINT = environment.apiUrl;
  public static NOTIFICATION_ENDPOINT = environment.notificationUrl;
  public static CUSTOMERREPORT_ENDPOINT = environment.customerReportUrl;
  public static AUTH = {
    login: "/pp/login",
    newPassword: "/pp/NewPassword",
    sendResetPasswordLink: "/pp/sendResetPasswordLink",
    logout: "/pp/logout",
    validateToken: "/pp/validateUserToken?",
    accessorg: "/pp/getOrgByPartner?request=",
    versionHistory: "/pp/getWhatsNewPageData?userType=",
    getNewLinkForUser: "/pp/getNewLinkForUser",
    userRevalidate: "/pp/userRevalidate?token=",
  }

  public static ZONE = {
    createZone: "/pp/createZone",
    updateZone: "/pp/updateZone",
    //getZone: "/pp/getZoneList?userName="
    getZone: "/pp/getZoneList"
  };
  public static GROUP = {
    createGroup: "/pp/createGroup",
    updateGroup: "/pp/updateGroup",
    getGroup: "/pp/GroupList"
  };

  public static ORGANISATION = {
    getOrganisation: "/pp/getOrganizationList",
    createOrganisation: "/pp/createOrganization",
    updateOrganisation: "/pp/updateOrganization",
    getOrganisationFilterList: "/pp/getOrganizationFilterList"
  }

  public static ROLES = {
    getAdminRoleList: "/pp/AdminRoleList",
    getOrgRoleList: "/pp/OrgRoleList?orgId=",
    getMenuList: "/pp/getMenuList",
    createAdminRole: "/pp/createAdminRole",
    createOrgRole: "/pp/createOrgRole",
    updateAdminRole: "/pp/updateAdminRole",
    updateOrgRole: "/pp/updateOrgRole",
    deleteAdminRole: "/pp/deleteadminole?roleId=",
    deleteOrgRole: "/pp/deleteorgrole?roleId=",
    getroleHolders: "/pp/roleassign",
    getUserRoleByEmailId: "/getUserRoleByEmailId"

  }

  public static CURBIORGANISATIONLIST = {
    getCurbiOrganizationList: "/pp/getCurbiOrganizationList"
  }
  //Notification endpoint

  public static NOTIFICATION = {
    getAllNotification: "/getNotificationState",
    getAllNotificationData: "/getNotificationData",
    toggleNotifications: "/toggleAllNotifications",
    updateNotification: "/updateNotification",
    getNotificationPartnerList:"/patnerZeroBalanceList",
    sendCustomDateNotification:"/sendCustomDateNotification"
  }

  //Customer Report

  public static CUSTOMERREPORT = {
    getCustomerReport: "/pp/getCustomerReport",
    getDestinationTypeList: "/pp/getDestinationTypeList",
    getPratnerListForCustomerReport: "/pp/getPratnerListForCustomerReport?product=?",
    getAllProduct: "/pp/getAllProduct",
    getAllPartnerType: "/pp/getPartnerType",
    getDateRangeLimit: "/pp/getDateRangeLimit",
  }

  //Two factor Authentication
  public static FAauthentication = {
    getUser2FASatus: "/get_user_2fa_status?userEmail=",
    getQRCode: "/get_user_qr_code?id=",
    enableUser2FA: "/set_up_user_two_fa",
    getFirstTimeLogin: "/update_user_first_time_login_flag",
    validateUser: "/validate_user",
    trunOff2FA: "/turn_off_2fa",
    reset2FA: "/send_reset_2fa_request?userEmail=",
    team2FAOnOff: "/orgFlagOnAndOff",
    team2FAOnOffForAdmin: "/systemFlagOnAndOff",
    disable2FA: "/disable_2fa",
    reset2FAlink: "/reset_2fa_if_link_active"
  }
  //Under Costruction
  public static underConstruction = {
    getUnderConstruction: "/pp/get_papi_work_status"
  }

  public static TRANSACTIONS = {
    getAllTransacton: "/pp/getAllTransaction",
    downloadxlsx: "/generateExcel",
    getTransactionById: "/pp/getTransactionById",
    getTransacionListById: "/pp/getTransactionByMFSId3PId",
    getExportDataOnTransaction:"/pp/export-all-transaction"
  }

  public static BALANCES = {
    getAllBalance: "/pp/getAllBalance",
    getAllBalanceById: "/pp/getAllBalanceById",
    getBalanceListById: "/pp/getBalanceByID",
    getExportDataOnBalance:"/pp/export-all-balance"
  }

  public static DASHBOARD = {
    getDashboard: "/pp/getDashBoard"
  }

  public static TRANSACTION_BALANCE_FILTER = {
    getStatus: "/pp/getTransactionStatus",
    getProduct: "/pp/getAllProduct?partnerCode=",
    getDirection: "/pp/getDirectionList",
    getDestinationType: "/pp/getDestinationTypeList",
    getCountries: "/pp/getAllCountries",
    getMovementType: "/getMovementType"
  }

  public static CUSTOM_FILTER = {
    addNewCustomFilter: "/addCustomFilter",
    getCustomReportFilters: "/getCustomReportFilters",
    updateCustomFilter: "/pp/updateCustomFilter",
    checkDuplicateName: "/pp/isCustomFilterPresent",
    deleteFilter: "/deleteCustomReportFilters"
  }

  public static UTIL = {
    currency: "/pp/getAllCurrencyDtoList",
    country: "/pp/getAllCountryDtoList",
    timezone: "/pp/getAllTimeZoneDtoList"
  }

  public static EXPORTAS = {
    balanceExcelExport: "/pp/genBalanceExcel",
    transactionExcelExport: "/pp/genTransactionExcel",
    reportExcelExport: "/pp/genReportExcel"
  }

  public static SETTINGS = {
    //User
    updateUser: "/pp/updateUser",
    changeUserPassword: "/pp/changeOrganisationPassword",
    registerUser: "/pp/registerUser",
    deleteUser: "/pp/deleteUser",
    getAllOrgUsers: "/pp/getAllUserByOrganisation/",
    profileInfo: "/pp/getUserByEmailId?email=",
    getOrgDetailsByName: "/pp/getOrganizationDetails?orgName=",

    //show hide api for notification tab

    activateModuleByPartner: "/activate-module-by-partner/moduleType?moduleType=Notification-Partner",
    activateCustomerReport: "/activate-module-by-partner/moduleType?moduleType=Customer-Report-internalUser",
    balancePageCustomFilter: "/activate-module-by-partner/moduleType?moduleType=Balance-CustomFilter",
    hubValueVolumePageCustomFilter: "/activate-module-by-partner/moduleType?moduleType=HubValueVolume-CustomFilter",
    partnerValueVolumePageCustomFilter: "/activate-module-by-partner/moduleType?moduleType=PartnerValueVolume-CustomFilter",
    whatsNewLink: "/activate-module-by-partner/moduleType?moduleType=WhatsNewPage-Link",
    balancePageNotification: "/activate-module-by-partner/moduleType?moduleType=Notification-tab-Balance",
    hubValueVolumePageNotification: "/activate-module-by-partner/moduleType?moduleType=Notification-tab-HubValueVolume",
    partnerValueVolumePageNotification: "/activate-module-by-partner/moduleType?moduleType=Notification-tab-PartnerValueVolume",
    partnerOutageDashboard: "/activate-module-by-partner/moduleType?moduleType=PartnerOutageDashboard",
    newDashboardPage: "/activate-module-by-partner/moduleType?moduleType=NewDashboardPage",


    //Admin
    changeAdminPassword: "/pp/changeAdminPassword",
    registerAdminUser: "/pp/inviteAdminUser",
    deleteAdminUser: "/pp/deleteAdminUser",
    updateAdminUser: "/pp/updateAdminUser",
    getAllSystemAdminUsers: "/pp/getAllSystemAdminUsers",
    //changeAdminPassword: "/pp/changeAdminPassword"
  }

// Partner outage dashboard
public static OUTAGE = {
  getAllOutageInfo:"/pp/getAllPartnerDetails",
  updateOutageInfo:"/updatePartnerDetails",
  partnerOutageInfo:"/getPartnerDetailsByPartnerCode"
}

  // regulater

  public static PRICING = {
    getPricingData: "/pp/getPricing",

  }

  public static CONTACT = {
    sendMessage: "/pp/sendMessage",
    getAllQueryTypes: "/pp/getQueryType",
    saveContact: "/pp/saveContact"
  }
  public static MONEYFLOW = {
    sendData: "/pp/moneyFlow",
    receiveData: "/pp/moneyFlow",
    getAllFilters: "/pp/getMoneyFilter"

  }

  public static HUBLEVEL = {
    getHubData: "/pp/getHubRecords",
    getProduct: "/getAllProductForHubReport",
    getExportData: "/getDetailedValuesVolumesReport",
    getCurbiCountries: "/pp/getAllCurbiCountries",
    getHubPartnerCountryListByCountryPartner: "/getHubPartnerCountryListByCountryPartner",
    getCountrylistByPartnerAndDirection: "/getCountrylistByPartnerAndDirection",
    getAllDirectionByPartner: "/pp/getAllDirectionByPartner?partnerCode=",
    getHubPartnerCountryListByDiretion: "/getHubPartnerCountryListByDirection",
    getPartnerListByCountry: "/getPartnerListByCountryFromPartner",

  }
  public static COMPLIANCE = {
    getComplianceSendToCountry: "/pp/getComplianceSendToCountry",
    getComplianceSendFromCountry: "/pp/ComplianceSendFromCountry",
    getComplianceReceiveFromCountry: "/pp/ComplianceReceiveFromCountry",
    getOrgDetailsByName: "/pp/getOrganizationDetail?orgName=",

    //Admin Compliance

    getAllPreviousGeneratedSTRReport: "/getAllPreviousGeneratedSTRReport",
    viewTransactionInfoByMfsId: "/viewTransactionInfoByMfsId",
    getAllIndicatorsFromLookup: "/getAllIndicatorsFromLookup",
    addRegulatorReferanceToReportAndSuspiciousTxn: "/addRegulatorReferanceToReportAndSuspiciousTxn",
    geneateStrReport: "/geneateStrReport",
    downloadStrReport: "/download",
    refreshJwtToken: "/pp/refresh_jwt_token"
  }

  public static STATISTICS = {
    getFilterData: "/pp/getStaticsticFilter",
    getConsumerData: "/pp/StatisticCounsumeDetails",
    getTransactionData: "/pp/getStatisticTransaction"
  }

  public static ORGANISATIONLIST = {
    getOrganizationList: "/pp/getOrganizationList",
    getOrganizationNameList: "/pp/getOrganizationLists"
  }

  public static MANAGEMULTIUSER = {
    getMultiUserByEmail: "/pp/GetMultiUserByEmail",
    multiUserInsertByAdmin: "/pp/MultiUserInsertByAdmin"
  }

  ngOnInit() {

  }


}
